// removed by extract-text-webpack-plugin
module.exports = {"text-overflow":"text-overflow___3Tw3_","nprogress-spinner":"nprogress-spinner___299Ka"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/app.less
// module id = 747
// module chunks = 3